interface Props {
  seed?: string;
}

export function Avatar({ seed }: Props) {
  return (
    <img
      className="rounded-full pointer-events-none h-10 w-10 object-cover aspect-square"
      src={`https://api.dicebear.com/5.x/initials/svg?seed=${seed?.replaceAll(' ', '-')}`}
      onError={(e) => {
        e.currentTarget.src = '/default-avatar.jpg';
      }}
      alt="avatar"
    />
  );
}
